import React, { Component } from "react";
import classnames from "classnames";
import styles from "./Components.local.scss";
import Percentage from "../../Common/Percentage/Percentage";
import _ from "i18n";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import { getLabelsByLng } from "../../../utils";

class ComponentHeader extends Component {
  render() {
    const {
      title,
      percentage,
      annexeAttachmentCategory,
      isComposition,
      isPresentation,
      hasComments,
      indicatorsExplanation,
      isPreparePresentation,
      lng,
      inSlideView
    } = this.props;
    return (
      <div className={styles.component_header}>
        <span className={styles.component_header_title}>
          {/*Titre du composant*/}
          {getLabelsByLng(title, lng)}
        </span>
        {isPresentation &&
          hasComments &&
          isPreparePresentation && (
            <span>
              <img
                className={styles.prepare_comment_icon}
                src={"/img/icons/comment.svg"}
                alt={""}
              />
            </span>
          )}
        {(isPresentation || isComposition) &&
          indicatorsExplanation !== null &&
          isPreparePresentation === false && (
            <span>
              <Tooltip placement="top" title={indicatorsExplanation}>
                <img
                  data-for="info__undefined"
                  data-tip=""
                  className={styles.comment_icon}
                  // className="Editor-local__formula_editor__info--1QOiF"
                  src="/img/icons/info.svg"
                  alt=""
                  currentitem="false"
                />{" "}
              </Tooltip>
            </span>
          )}
        {annexeAttachmentCategory && !inSlideView ? (
          <span
            className={classnames(styles.component_header_annexe_attachment)}
            onClick={() =>
              isComposition !== true
                ? this.props.handleDisplayAnnexePDF(annexeAttachmentCategory)
                : ""
            }
          >
            <i className={"icon icon-docs"} /> {_("seeMore")}
          </span>
        ) : percentage ? (
          <span
            className={classnames(
              styles.component_header_percentage_span,
              percentage > 0 ? styles.positive : styles.negative
            )}
          >
            <Percentage percentage={percentage} />
          </span>
        ) : null}
        <hr />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  configComponent: state.slideComposition.componentConfig,
  components: state.slideComposition.composition.layout.components,
  lng: state.params.lng
});

export default connect(mapStateToProps)(ComponentHeader);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Components/ComponentHeader.js